import { FAKE, REAL, registerDependency } from '@cloudsuite/mosaic-shared/scripts/dependency-injection.js'

export const GET_PAYMENT_METHODS_API = Symbol('PAYMENT_METHODS_API')

export class GetPaymentMethodsRequest {
  url: URL
  method = 'GET' as const

  constructor(url: URL) {
    this.url = url
  }
}

export type GetPaymentMethodsApi = {
  getPaymentMethods: (request: GetPaymentMethodsRequest) => Promise<unknown>
}

@registerDependency(FAKE, GET_PAYMENT_METHODS_API)
export class FakeGetPaymentMethodsApi implements GetPaymentMethodsApi {
  requests: GetPaymentMethodsRequest[] = []
  response: any

  getPaymentMethods = async (request: GetPaymentMethodsRequest): Promise<unknown> => {
    this.requests.push(request)
    return this.response
  }
}

@registerDependency(REAL, GET_PAYMENT_METHODS_API)
export class RealGetPaymentMethodsApi implements GetPaymentMethodsApi {
  getPaymentMethods = async (request: GetPaymentMethodsRequest): Promise<unknown> => {
    const response = await fetch(request.url, { method: request.method })
    return await response.json()
  }
}
